import { Delay } from './settlementschedule/Delay';
import { Interval } from './settlementschedule/Interval';
export const SettlementSchedule = {
    delay: Delay,
    interval: Interval,
};
